import React, { useState, useEffect } from "react";

function HeaderTable({ onChange }) {
  const [sortType, setSortType] = useState({ column: null, type: null });
  const [pendingSort, setPendingSort] = useState(null);
  const [filterVisible, setFilterVisible] = useState({
    name: null,
    id: null,
    type: null,
    amount: null,
    projectId: null,
    complainAmount: null,
    total: null,
  });

  useEffect(() => {
    if (pendingSort) {
      onChange?.(pendingSort);
      setPendingSort(null);
    }
  }, [pendingSort, onChange]);

  const toggleSort = (column) => {
    setFilterVisible((prev) => {
      const current = prev[column];
      const nextState = current === "asc" ? "desc" : current === "desc" ? null : "asc";

      const resetAll = Object.fromEntries(Object.keys(prev).map((key) => [key, null]));
      return { ...resetAll, [column]: nextState };
    });

    setSortType((prev) => {
      const next = prev.column === column ? (prev.type === "asc" ? "desc" : prev.type === "desc" ? null : "asc") : "asc";
      setPendingSort({ sortBy: column, sortType: next });
      return { column, type: next };
    });
  };

  const widthStyle = {
    no: {
      width: "80px",
      minWidth: "80px",
      maxWidth: "80px",
      flexShrink: "0",
      position: "sticky",
      left: "0",
      backgroundColor: "#f8f8f8",
    },
    worker_id: {
      width: "135px",
      minWidth: "135px",
      maxWidth: "135px",
      flexShrink: "0",
      position: "sticky",
      left: "80px",
      backgroundColor: "#f8f8f8",
    },
    worker_name: {
      width: "200px",
      minWidth: "200px",
      maxWidth: "200px",
      flexShrink: "0",
      position: "sticky",
      left: "215px",
      backgroundColor: "#f8f8f8",
    },
    worker_type: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    initial_amount: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    project_id: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    amount_complain: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    final_amount: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    action: {
      width: "135px",
      minWidth: "135px",
      maxWidth: "135px",
      flexShrink: "0",
      position: "sticky",
      right: "0",
      backgroundColor: "#f8f8f8",
    },
  };

  const columns = [
    { key: "no", label: "No", sortAble: false },
    { key: "worker_id", label: "Worker ID", sortAble: true },
    { key: "worker_name", label: "Worker Name", sortAble: true },
    { key: "worker_type", label: "Worker Type", sortAble: true },
    { key: "initial_amount", label: "Amount", sortAble: true },
    { key: "project_id", label: "Project ID Complain", sortAble: false },
    { key: "amount_complain", label: "Amount Complain", sortAble: false },
    { key: "final_amount", label: "Total Amount", sortAble: true },
    { key: "action", label: "Action", sortAble: false },
  ];

  return (
    <>
      {columns.map((col, index) => (
        <div
          key={col.key}
          onClick={col.sortAble ? () => toggleSort(col.key) : null}
          className={`flex flex-row justify-content-between align-items-center p-3 m-0 p-0 w-full 
            ${col.sortAble ? "select-none cursor-pointer" : ""}
            ${
              index === columns.length - 1
                ? "border-left-1 border-200"
                : index < columns.length - 2
                ? "border-right-1 border-200"
                : ""
            }`}
          style={{ ...widthStyle[col.key], height: "50px", minHeight: "50px", maxHeight: "50px" }}
        >
          <h6 className="fw-bold m-0" style={{ fontSize: "13px" }}>
            {col.label}
          </h6>

          <div className="flex flex-row justify-content-center align-items-center gap-2">
            {col.sortAble && filterVisible[col.key] && (
              <div className="flex flex-row justify-content-center align-items-center gap-2">
                <i
                  className={`pi ${filterVisible[col.key] === "asc" ? "pi-arrow-down" : "pi-arrow-up"} text-xs`}
                  style={{ color: "#708090" }}
                ></i>
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
}

export default HeaderTable;
